export default __webpack_public_path__ + "static/img6-bd0c1e3384af456ed0595d44dc84947c.png";